function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var FAQ = function FAQ(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    d: "M11.89 15.75a1.01 1.01 0 1 0 0-2.02 1.01 1.01 0 0 0 0 2.02M11.89 12.43c-.41 0-.75-.34-.75-.75 0-.7.08-1.43.68-2.05.18-.18.4-.38.62-.57.29-.25.59-.51.76-.73.32-.42.41-.94.24-1.4-.16-.44-.54-.75-1.06-.86-.82-.19-1.73.29-1.94 1.02-.11.4-.53.63-.93.51A.74.74 0 0 1 9 6.67c.43-1.48 2.12-2.42 3.71-2.07 1.02.23 1.8.89 2.14 1.81.34.93.18 1.99-.45 2.82-.26.35-.63.67-.98.97-.19.16-.38.32-.52.48-.2.2-.26.46-.26 1.01 0 .41-.34.75-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    d: "M21.25 5c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v11c0 .69.56 1.25 1.25 1.25h12.299c.624 0 1.23.212 1.718.602l2.827 2.262.064.038a.25.25 0 0 0 .342-.233zm1.5 14.919c0 1.421-1.593 2.232-2.734 1.448l-.109-.08-2.828-2.263a1.25 1.25 0 0 0-.78-.274H4A2.75 2.75 0 0 1 1.25 16V5A2.75 2.75 0 0 1 4 2.25h16A2.75 2.75 0 0 1 22.75 5z"
  }));
};
export default FAQ;
FAQ.displayName = 'FAQ';